/* Owner's request, 2026-09-19, changed 2026-10-14: copying is ALLOWED, but a copied passage
   carries her copyright and the page's address with it. Nothing is blocked any more - the
   description can be selected and copied like any other text (it used to be locked).
   Short copies - a title, a measurement, the email address - are left untouched, so a buyer is
   never getting in their own way. A credit line is a courtesy, not a defence: a site that scrapes
   the page is not slowed by it, which is why every photograph also carries its watermark. */
(() => {
  const STUDIO = 'Noblesse Oblige Studio';
  const PASSAGE = 80;                              // characters; below this, copying is left alone

  document.addEventListener('copy', e => {
    const sel = document.getSelection();
    const text = sel ? sel.toString() : '';
    if (text.trim().length < PASSAGE) return;
    const canonical = document.querySelector('link[rel="canonical"]');
    const address = canonical ? canonical.href : location.href.split(/[?#]/)[0];
    const year = new Date().getFullYear();
    e.clipboardData.setData('text/plain',
      `${text}\n\n© ${year} ${STUDIO}. ${address}`);
    e.preventDefault();
  });
})();
